import { useEffect, useState } from 'react'
import { coursesAPI } from '../../services/api'
import type { Course } from '../../types'
import CourseCard from './CourseCard'

/**
 * A creator's published courses, for their pages. Shows nothing when they
 * have none (or the list can't be had): a page doesn't need an empty box.
 */
const CreatorCourses = ({ creatorId, dark = false }: { creatorId: number; dark?: boolean }) => {
  const [courses, setCourses] = useState<Course[]>([])

  useEffect(() => {
    let stopped = false
    coursesAPI
      .byInstructor(creatorId)
      .then((list) => !stopped && setCourses(list.filter((c) => c.status === 'published')))
      .catch(() => undefined)
    return () => {
      stopped = true
    }
  }, [creatorId])

  if (courses.length === 0) return null
  return (
    <section aria-labelledby="creator-courses" data-testid="creator-courses">
      <h2
        id="creator-courses"
        className={`mb-2 text-[11px] font-medium uppercase tracking-wider ${dark ? 'text-gray-500' : 'text-gray-600'}`}
      >
        Courses
      </h2>
      <ul className="grid gap-3 sm:grid-cols-2">
        {courses.map((course) => (
          <li key={course.id}>
            <CourseCard course={course} dark={dark} />
          </li>
        ))}
      </ul>
    </section>
  )
}

export default CreatorCourses
